<div class="space-y-6">
  <!-- Header
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
          {{ 'DEBTORS.TITLE' | translate }}
        </h1>
        <p class="text-gray-600 dark:text-gray-400 mt-1">{{ 'DEBTORS.SUBTITLE' | translate }}</p>
      </div>
    </div> -->

  <!-- Filters -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row sm:items-end gap-3">
      <span class="w-full sm:w-72 min-w-0">
        <input
          pInputText
          type="text"
          class="w-full"
          [placeholder]="'DEBTORS.SEARCH_PLACEHOLDER' | translate"
          [ngModel]="searchTerm()"
          (ngModelChange)="onSearchChange($event)"
        />
      </span>
      <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
      @if (storePick.visible()) {
        <p-multiselect
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'DEBTORS.STORE_FILTER' | translate"
          [showClear]="true"
          [(ngModel)]="filterStoreIds"
          (onChange)="onFilterChange()"
          appendTo="body"
          display="chip"
          class="w-full sm:w-72 min-w-0"
        />
      }
      <p-button
        icon="pi pi-refresh"
        [label]="'DEBTORS.REFRESH' | translate"
        severity="secondary"
        (onClick)="onFilterChange()"
        class="self-stretch sm:self-end"
      />
    </div>
  </div>

  <!-- Table -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
  >
    <div class="overflow-x-auto">
      <p-table
        [value]="debtors()"
        [lazy]="true"
        (onLazyLoad)="load($event)"
        [totalRecords]="totalCount()"
        [paginator]="true"
        [rows]="pageSize"
        [rowsPerPageOptions]="[20, 50, 100]"
        [loading]="loading()"
        [showCurrentPageReport]="false"
        [showFirstLastIcon]="false"
        styleClass="p-datatable-gridlines"
        [tableStyle]="{ 'min-width': '60rem' }"
        dataKey="rowKey"
        [expandedRowKeys]="expandedRowKeys"
        (onRowExpand)="onRowExpand($event.data)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th style="width: 3rem">#</th>
            <th>{{ 'DEBTORS.TABLE.CUSTOMER' | translate }}</th>
            <th>{{ 'DEBTORS.TABLE.PHONE' | translate }}</th>
            <th>{{ 'DEBTORS.TABLE.INITIAL_DEBT' | translate }}</th>
            <th>{{ 'DEBTORS.TABLE.REMAINING_DEBT' | translate }}</th>
            <th>{{ 'DEBTORS.TABLE.ORDERS_COUNT' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-debtor let-expanded="expanded" let-rowIndex="rowIndex">
          <tr>
            <td>
              <button
                type="button"
                pButton
                pRipple
                [pRowToggler]="debtor"
                class="p-button-text p-button-rounded p-button-plain p-1"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              >
                <span class="sr-only">Toggle</span>
              </button>
            </td>
            <td class="text-gray-500 dark:text-gray-400 text-sm">{{ rowIndex + 1 }}</td>
            <td class="font-medium text-gray-900 dark:text-gray-100">
              {{ debtor.customerName || '—' }}
            </td>
            <td>
              {{ debtor.customerPhone || '—' }}
            </td>
            <td class="font-semibold text-gray-600 dark:text-gray-300">
              {{ debtor.totalDebt | money: debtor.currency }}
            </td>
            <td>
              <span class="font-bold text-red-600 dark:text-red-400">
                {{ debtor.remainingDebt | money: debtor.currency }}
              </span>
            </td>
            <td class="text-sm text-gray-600 dark:text-gray-400">
              {{
                'DEBTORS.TABLE.ORDERS_COUNT_LABEL' | translate: { count: debtor.debtOrdersCount }
              }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="expandedrow" let-debtor>
          <tr>
            <td colspan="7" class="bg-gray-50 dark:bg-gray-800/40 p-4">
              <div
                class="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4 shadow-inner"
              >
                <h3
                  class="text-base font-bold text-gray-800 dark:text-gray-200 mb-3 flex items-center gap-2"
                >
                  <i class="pi pi-receipt text-emerald-500"></i>
                  {{ 'DEBTORS.ACTIVE_DEBT_PURCHASES' | translate }}
                </h3>

                @if (expandedDebts()[debtor.rowKey]?.loading) {
                  <div class="flex items-center justify-center py-6 gap-2">
                    <i class="pi pi-spin pi-spinner text-xl text-emerald-500"></i>
                    <span class="text-sm text-gray-500">{{ 'COMMON.LOADING' | translate }}</span>
                  </div>
                } @else {
                  <p-table
                    [value]="expandedDebts()[debtor.rowKey]?.items ?? []"
                    styleClass="p-datatable-striped"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>{{ 'DEBTORS.TABLE.RECEIPT' | translate }}</th>
                        <th>{{ 'DEBTORS.TABLE.DATE' | translate }}</th>
                        <th>{{ 'DEBTORS.TABLE.TOTAL' | translate }}</th>
                        <th>{{ 'DEBTORS.TABLE.PAID' | translate }}</th>
                        <th>{{ 'DEBTORS.TABLE.REMAINING' | translate }}</th>
                        <th>{{ 'DEBTORS.TABLE.DUE_DATE' | translate }}</th>
                        <th>{{ 'DEBTORS.TABLE.STORE' | translate }}</th>
                        <th style="width: 8rem">{{ 'DEBTORS.TABLE.ACTIONS' | translate }}</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-order>
                      <tr>
                        <td>
                          <code class="text-xs bg-gray-100 dark:bg-gray-600 px-2 py-0.5 rounded">
                            {{ order.receiptNumber }}
                          </code>
                        </td>
                        <td class="text-sm text-gray-600 dark:text-gray-400">
                          {{ order.orderDate | date: 'dd.MM.yyyy HH:mm' }}
                        </td>
                        <td class="font-semibold text-gray-900 dark:text-gray-100">
                          {{ order.totalAmount | money: order.currency }}
                        </td>
                        <td class="text-gray-600 dark:text-gray-400">
                          {{ order.paidAmount | money: order.currency }}
                        </td>
                        <td>
                          <span class="font-bold text-red-600 dark:text-red-400">
                            {{ remaining(order) | money: order.currency }}
                          </span>
                        </td>
                        <td class="text-sm">
                          @if (order.debtDueDate) {
                            <span
                              [class.text-red-600]="isOverdue(order.debtDueDate)"
                              [class.dark:text-red-400]="isOverdue(order.debtDueDate)"
                              [class.font-semibold]="isOverdue(order.debtDueDate)"
                              [class.text-gray-600]="!isOverdue(order.debtDueDate)"
                              [class.dark:text-gray-400]="!isOverdue(order.debtDueDate)"
                            >
                              {{ order.debtDueDate | date: 'dd.MM.yyyy' }}
                              @if (isOverdue(order.debtDueDate)) {
                                <i class="pi pi-exclamation-triangle text-xs ml-1"></i>
                              }
                            </span>
                          } @else {
                            <span class="text-gray-400 dark:text-gray-650">—</span>
                          }
                        </td>
                        <td class="text-gray-600 dark:text-gray-400 text-sm">
                          {{ order.storeName }}
                        </td>
                        <td>
                          <p-button
                            icon="pi pi-wallet"
                            [label]="'DEBTORS.PAY_BTN' | translate"
                            severity="success"
                            size="small"
                            (onClick)="openPayDialog(order)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="8" class="text-center py-6 text-gray-500">
                          {{ 'DEBTORS.NO_DEBT_FOUND' | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                }
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center py-12 text-gray-500 dark:text-gray-400">
              <div class="flex flex-col items-center gap-2">
                <i class="pi pi-check-circle text-4xl text-gray-300"></i>
                <span>{{ 'DEBTORS.EMPTY' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Pay Debt Dialog -->
<p-dialog
  [header]="'DEBTORS.PAY_DIALOG.TITLE' | translate"
  [(visible)]="payDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(54rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closePayDialog()"
>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
    <!-- chap ustun: Chek ko'rinishi -->
    <div
      class="border-t md:border-t-0 md:border-l border-gray-200 dark:border-gray-800 pt-4 md:pt-0 md:pl-6 flex flex-col gap-3"
    >
      <div class="flex items-center justify-between">
        <h4 class="font-bold text-gray-855 dark:text-gray-200">
          {{ 'DEBTORS.PAY_DIALOG.RECEIPT_PREVIEW' | translate }}
        </h4>
        @if (receiptData()) {
          <div class="flex flex-wrap gap-2 justify-end">
            <p-button
              icon="pi pi-file-pdf"
              [label]="'SALES.RECEIPT.PDF' | translate"
              size="small"
              severity="secondary"
              [outlined]="true"
              [loading]="exportBusy()"
              (onClick)="downloadReceiptPdf()"
            />
            <p-button
              icon="pi pi-share-alt"
              [label]="'SALES.RECEIPT.SHARE' | translate"
              size="small"
              severity="secondary"
              [outlined]="true"
              [loading]="shareBusy()"
              (onClick)="shareReceipt()"
            />
            <p-button
              icon="pi pi-print"
              [label]="'DEBTORS.PAY_DIALOG.PRINT' | translate"
              size="small"
              severity="secondary"
              (onClick)="printReceipt()"
            />
          </div>
        }
      </div>

      <div
        class="border border-gray-200 dark:border-gray-700 rounded-xl p-4 bg-white dark:bg-gray-950 max-h-[350px] overflow-y-auto shadow-inner"
      >
        @if (loadingReceipt()) {
          <div class="flex flex-col items-center justify-center py-12 gap-2">
            <i class="pi pi-spin pi-spinner text-2xl text-emerald-500"></i>
            <span class="text-sm text-gray-500">{{
              'DEBTORS.PAY_DIALOG.LOADING_RECEIPT' | translate
            }}</span>
          </div>
        } @else if (receiptData(); as data) {
          <app-receipt [receipt]="data" />
        } @else {
          <div class="text-center py-12 text-gray-400 dark:text-gray-500 text-sm">
            {{ 'DEBTORS.PAY_DIALOG.LOAD_RECEIPT_ERROR' | translate }}
          </div>
        }
      </div>
    </div>

    <!-- o'ng ustun: To'lov shakli va tafsilotlar -->
    <div class="flex flex-col gap-4">
      @if (payingDebt) {
        <div class="rounded-lg bg-gray-50 dark:bg-gray-800 p-3 flex flex-col gap-2 text-sm">
          <div class="flex justify-between">
            <span class="text-gray-500 dark:text-gray-400">{{
              'DEBTORS.PAY_DIALOG.CUSTOMER' | translate
            }}</span>
            <span class="font-medium">{{ payingDebt.debtCustomerName || '—' }}</span>
          </div>
          @if (payingDebt.debtCustomerPhone) {
            <div class="flex justify-between">
              <span class="text-gray-500 dark:text-gray-400">{{
                'DEBTORS.PAY_DIALOG.PHONE' | translate
              }}</span>
              <span>{{ payingDebt.debtCustomerPhone }}</span>
            </div>
          }
          <div class="flex justify-between">
            <span class="text-gray-500 dark:text-gray-400">{{
              'DEBTORS.PAY_DIALOG.RECEIPT' | translate
            }}</span>
            <code class="text-xs bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded">{{
              payingDebt.receiptNumber
            }}</code>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-500 dark:text-gray-400">{{
              'DEBTORS.PAY_DIALOG.STORE' | translate
            }}</span>
            <span>{{ payingDebt.storeName }}</span>
          </div>
          <div class="border-t border-gray-200 dark:border-gray-700 pt-2 flex justify-between">
            <span class="text-gray-500 dark:text-gray-400">{{
              'DEBTORS.PAY_DIALOG.TOTAL' | translate
            }}</span>
            <span>{{ payingDebt.totalAmount | money: payingDebt.currency }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-500 dark:text-gray-400">{{
              'DEBTORS.PAY_DIALOG.PAID' | translate
            }}</span>
            <span class="text-green-600 dark:text-green-400">{{
              payingDebt.paidAmount | money: payingDebt.currency
            }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-500 dark:text-gray-400">{{
              'DEBTORS.PAY_DIALOG.TOTAL_DEBT' | translate
            }}</span>
            <span class="font-bold text-red-600 dark:text-red-400">
              {{ remaining(payingDebt) | money: payingDebt.currency }}
            </span>
          </div>
        </div>
      }

      <!-- Qaysi pulda to'laydi. Faqat kursi ma'lum bo'lgan valyutalar chiqadi va
           bir nechta variant bo'lgandagina ko'rinadi (bitta valyutali biznesda
           dialog avvalgidek qoladi). -->
      @if (payCurrencyOptions.length > 1) {
        <div class="flex flex-col gap-1">
          <!-- `<label>` emas: p-selectbutton tugmalar guruhini chizadi, unda
               bog'lanadigan form elementi yo'q. Guruh nomi aria-label orqali beriladi. -->
          <span
            id="pay-currency-label"
            class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            {{ 'DEBTORS.PAY_DIALOG.PAY_CURRENCY' | translate }}
          </span>
          <p-selectbutton
            [options]="payCurrencyOptions"
            [(ngModel)]="payCurrency"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false"
            ariaLabelledBy="pay-currency-label"
            (onChange)="onPayCurrencyChange()"
          />
        </div>

        @if (isCrossCurrencyPayment) {
          <!-- Kurs va undiriladigan summa. Kurs eskirgan bo'lsa qizil, lekin
               to'lov to'xtamaydi — foydalanuvchi faqat nima bo'layotganini bilsin. -->
          <div
            class="text-sm flex justify-between"
            [class.text-red-600]="isPayRateStale"
            [class.dark:text-red-400]="isPayRateStale"
            [class.text-gray-500]="!isPayRateStale"
            [class.dark:text-gray-400]="!isPayRateStale"
          >
            <span>1 {{ debtCurrency }} = {{ payRate | money: payCurrency }}</span>
            <span class="font-semibold">
              {{ 'DEBTORS.PAY_DIALOG.TO_COLLECT' | translate }}:
              {{ maxPayable | money: payCurrency }}
            </span>
          </div>
        }
      }

      <div class="flex flex-col gap-1">
        <label for="pay-amount" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'DEBTORS.PAY_DIALOG.AMOUNT' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-inputnumber
          inputId="pay-amount"
          [min]="0"
          [max]="maxPayable"
          [(ngModel)]="payAmount"
          [useGrouping]="true"
          mode="decimal"
          [maxFractionDigits]="currencySvc.info(payCurrency).decimals"
          class="w-full"
          [styleClass]="isPayAmountOverMax ? 'ng-invalid ng-dirty w-full' : 'w-full'"
        />
        <!-- Chegara har doim ko'rinadi: foydalanuvchi uni KIRITISHDAN OLDIN bilsin,
             tasdiqlab, xato olib emas. -->
        <small
          [class]="
            isPayAmountOverMax
              ? 'text-red-600 dark:text-red-400'
              : 'text-gray-500 dark:text-gray-400'
          "
        >
          @if (isPayAmountOverMax) {
            {{
              'DEBTORS.PAY_DIALOG.OVER_MAX' | translate: { max: maxPayable | money: payCurrency }
            }}
          } @else {
            {{ 'DEBTORS.PAY_DIALOG.MAX' | translate }}: {{ maxPayable | money: payCurrency }}
          }
        </small>
      </div>

      <!-- Pul QANDAY qabul qilingani — naqd/karta/bank moslashsa kassa hisoboti
           to'g'ri chiqadi. Ilgari bu yerda tanlov yo'q edi va har bir qarz
           to'lovi doim NAQD deb yozilardi. -->
      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'DEBTORS.PAY_DIALOG.PAY_METHOD' | translate }}
        </span>
        <div class="grid grid-cols-3 gap-2">
          @for (opt of payMethodOptions; track opt.value) {
            <button
              type="button"
              (click)="payMethod = opt.value"
              class="py-2 rounded-lg border-2 text-sm font-semibold transition-all text-center"
              [class.border-emerald-500]="payMethod === opt.value"
              [class.bg-emerald-50]="payMethod === opt.value"
              [class.text-emerald-700]="payMethod === opt.value"
              [class.dark:bg-emerald-900/30]="payMethod === opt.value"
              [class.dark:text-emerald-300]="payMethod === opt.value"
              [class.border-gray-200]="payMethod !== opt.value"
              [class.dark:border-gray-700]="payMethod !== opt.value"
              [class.text-gray-600]="payMethod !== opt.value"
              [class.dark:text-gray-400]="payMethod !== opt.value"
            >
              {{ opt.label | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'DEBTORS.PAY_DIALOG.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="closePayDialog()"
      [disabled]="payingSaving"
    />
    <p-button
      [label]="'DEBTORS.PAY_DIALOG.CONFIRM' | translate"
      icon="pi pi-check"
      severity="success"
      (onClick)="confirmPayment()"
      [loading]="payingSaving"
      [disabled]="!isPayAmountValid"
    />
  </ng-template>
</p-dialog>
